import jwtDecode from 'jwt-decode';
import * as moment from 'moment';
import {useEffect} from 'react';
import Cookies from 'universal-cookie';
import query from '../_mutations/renewalToken';
import {useMutation} from "@apollo/client";

const cookies = new Cookies();
const expire_after = 600;

const RenewToken = ({children}) => {
    const [mutate] = useMutation(query);

    const updateToken = async () => {
        const {data} = await mutate({
            variables: {
                expire_after
            }
        });
        cookies.set('token', data.renewAuthToken, {path: '/'});
    }

    const checkToken = () => {
        const token = cookies.get('token');
        const JWT = jwtDecode(token);
        const d = new Date(0);
        d.setUTCSeconds(JWT.exp);

        const tokenDate = moment(d);
        const currentDate = moment(new Date());
        const diff = tokenDate.diff(currentDate) / 60000;
        if (diff < 5) {
            updateToken();
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            checkToken();
        }, 60000);
        return () => clearInterval(interval);
    });

    return children;
}

export default RenewToken;
